<template>
  <v-dialog
    v-model="showDialog"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>Add Asset</v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter.native="actionClick()"
        >
          <v-select
            ref="assetType"
            v-model="assetType"
            :items="assetTypeList"
            item-text="label"
            item-value="id"
            :rules="[validateRequired]"
            label="Type"
            required
            @input="assetTypeDirty = true"
          />
          <v-text-field
            ref="assetId"
            v-model="assetId"
            label="Asset ID"
          />
          <v-text-field
            ref="assetName"
            v-model="assetName"
            :rules="[validateRequired]"
            label="Asset Name"
            required
            @blur="assetNameDirty = true"
          />
          <v-textarea
            ref="details"
            v-model="details"
            :rules="[validateRequired]"
            label="Details"
            required
            rows="3"
            @blur="detailsDirty = true"
          />
          <v-text-field
            ref="dateObtained"
            v-model="dateObtained"
            :rules="[validateRequired]"
            label="Date Obtained"
            required
            type="date"
            @blur="dateObtainedDirty = true"
          />
          <v-select
            ref="currencyType"
            v-model="currencyType"
            :items="currencyTypeList"
            item-text="label"
            item-value="id"
            :rules="[validateRequired]"
            label="Currency"
            required
            @blur="currencyTypeValueDirty = true"
          />
          <v-text-field
            ref="entryValue"
            v-model="entryValue"
            :rules="[validateAssetValue]"
            label="Asset Value"
            type="number"
            required
            @blur="entryValueDirty = true"
          />
          <v-select
            ref="documentId"
            v-model="documentId"
            :items="vaultDocuments"
            item-value="id"
            item-text="name"
            label="Document"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          small
          text
          @click.stop="cancelClick()"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="!valid || submitting"
          :loading="submitting"
          color="primary"
          small
          @click.stop="actionClick()"
        >
          Add Asset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validateRequired, validateMinimumOf } from '@/utils/validationRules'
import { firebase } from '@/firebase'
import { listAssets } from '@/dataAccess/assets'
import { createAssetId } from '@/utils/assetId'
import { CURRENCIES_LIST } from '@/dataAccess/currencies'
import { ASSET_TYPES_LIST } from '@/dataAccess/assetTypes'

export default {
  name: 'AddAssetDialog',
  props: {
    showDialog: { type: Boolean, default: false }
  },
  data: function () {
    return {
      valid: false,
      assetId: null,
      assetIdDirty: false,
      assetType: null,
      assetTypeDirty: false,
      assetName: null,
      assetNameDirty: false,
      details: null,
      detailsDirty: false,
      dateObtained: null,
      dateObtainedDirty: false,
      entryValue: null,
      currencyType: null,
      entryValueDirty: false,
      submitting: false,
      assetTypeList: ASSET_TYPES_LIST,
      currencyTypeValueDirty: false,
      currencyTypeList: CURRENCIES_LIST,
      documentId: null
    }
  },
  watch: {
    showDialog: function (showDialog) {
      if (showDialog && this.$refs && this.$refs.form) {
        this.$refs.form.reset()
        Object.assign(this.$data, this.$options.data())
      }
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_account', 'get_appUser', 'get_vaultDocuments'])
    this.mapStates(['account', 'appUser', 'vaultDocuments'])
  },
  methods: {
    validateRequired,
    validateAssetValue: validateMinimumOf(0, 'Asset value cannot be negative or empty'),
    async actionClick() {
      Object.entries(this.$data).forEach(([key, value]) => {
        if (key.includes('Dirty')) {
          this[key] = true
        }
      })

      if (this.$refs.form.validate()) {
        this.$handlingError(
          `Error adding asset "${this.assetName}"`,
          async () => {
            this.submitting = true
            const payload = {
              assetId: this.assetId || createAssetId(),
              assetName: this.assetName,
              assetType: this.assetType,
              details: this.details,
              dateObtained: this.dateObtained,
              currencyType: this.currencyType,
              entryValue: this.entryValue,
              accountId: this.account.id,
              userId: this.appUser.id,
              timestamp: firebase.firestore.FieldValue.serverTimestamp(),
              status: '',
              documentId: this.documentId,
              docSigned: true
            }

            await listAssets().add(payload)

            this.$emit('cancelClick')

            this.$showSuccessbar('Asset added')
            this.submitting = false
          }
        )
      }
    },
    cancelClick() {
      this.$emit('cancelClick')
    }
  }
}
</script>
